import { render, staticRenderFns } from "./VRadios.vue?vue&type=template&id=0fccec07"
import script from "./VRadios.vue?vue&type=script&lang=js"
export * from "./VRadios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports